import React, { useEffect, useRef, useState } from "react";
import "./Crm.scss";
import CustomTextField from "../../../TextFiled/Index";
import NewReport from "./NewReport/NewReport";
import ActiveReport from "./ActiveReport/ActiveReport";
import InActiveReport from "./InActiveReport/InActiveReport";
import { crmActiveTab } from "../../../Recoil/atom";
import { useRecoilState, useRecoilValue } from "recoil";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useNavigate } from "react-router-dom";
import { CommonAPImain } from "../../../../Utils/API/CommonAPImain/CommonAPImain";
import { DataGrid } from "@mui/x-data-grid";
import { Box, IconButton, Typography } from "@mui/material";
import { IoMdClose } from "react-icons/io";

const Crm = () => {
  const [activeTab, setActiveTab] = useRecoilState(crmActiveTab);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const searchBarRef = useRef(null);
  const [filters, setFilters] = useState({
    CustomerCode: "",
    Email: "",
    FullName: "",
    MobileNo: "",
  });

  const handleTabChange = (tab) => {
    if (tab === "search") {
      setShowSearchBar(!showSearchBar);
    } else {
      setActiveTab(tab);
      setShowSearchBar(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBarRef.current &&
        !searchBarRef.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }
    };

    if (showSearchBar) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSearchBar]);

  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
  };

  const handleClearFilters = () => {
    setFilters({
      CustomerCode: "",
      Email: "",
      FullName: "",
      MobileNo: "",
    });
    setShowSearchBar(false);
  };
  const isAnyFilterEntered = Object.values(filters).some(
    (value) => value.trim() !== ""
  );

  //newwwwwwwwwwwwwwwwww
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const gridRef = useRef(null);
  const { CustomerCode, Email, FullName, MobileNo } = filters;

  useEffect(() => {
    const handleResize = () => {
      if (gridRef.current) {
        gridRef.current.style.height = `${window.innerHeight - 270}px`;
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = [
    {
      field: "FLname",
      headerName: "Full Name",
      width: 140,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              justifyContent: "center",
            }}
            onClick={() => {
              sessionStorage.setItem(
                "CustomerId_CRMCall",
                params.row.CustomerId
              );
              sessionStorage.setItem(
                "CustomerFLname_CRMCall",
                params.row.FLname
              );
              sessionStorage.setItem(
                "CustomerCode_CRMCall",
                params.row.CustomerCode
              );

              navigate("/CrmDetail");
            }}
          >
            <p
              style={{
                height: "20px",
                margin: "0px",
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                textDecoration: "underline",
              }}
            >
              {params.row.Firstname} {params.row.Lastname}
            </p>
            <p
              style={{
                height: "20px",
                margin: "0px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {params.row.CustomerCode}
            </p>
          </div>
        );
      },
    },
    {
      field: "OrderCnt",
      headerName: "Order Count",
      width: 120,
      renderCell: (params) => {
        return (
          <div>
            <p style={{ margin: "0px", textAlign: "center" }}>
              {params.row.OrderCnt}
            </p>
          </div>
        );
      },
    },
    { field: "mobileno", headerName: "Mobile No.", width: 150 },
    { field: "email1", headerName: "Email", width: 150 },
  ];

  useEffect(() => {
    setIsLoading(true);
    CommonAPImain("CRM_NewCustomerList")
      .then((response) => {
        setIsLoading(false);
        if (response?.Data?.DT) {
          setRows(
            response.Data.DT.map((item, index) => ({
              id: index + 1,
              ...item,
            }))
          );
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("API Error:", err);
      });
  }, [activeTab]);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const filteredRows = rows.filter((row) => {
    const matchesFilters =
      (!CustomerCode ||
        row.CustomerCode.toLowerCase().includes(CustomerCode.toLowerCase())) &&
      (!Email || row.email1.toLowerCase().includes(Email.toLowerCase())) &&
      (!FullName ||
        row.FLname.toLowerCase().includes(FullName.toLowerCase())) &&
      (!MobileNo || row.mobileno.includes(MobileNo));

    const matchesSearchQuery =
      !searchQuery ||
      row.CustomerCode.toLowerCase().includes(searchQuery) ||
      row.email1.toLowerCase().includes(searchQuery) ||
      row.FLname.toLowerCase().includes(searchQuery) ||
      row.mobileno.includes(searchQuery);

    return matchesFilters && matchesSearchQuery;
  });

  const clearSearch = () => {
    setSearchQuery("");
  };

  //new.............................
  const [inActiveRows, setInActiveRows] = useState([]);
  const [inActiveSearchQuery, setInActiveSearchQuery] = useState("");
  const activeTabInactive = useRecoilValue(crmActiveTab);

  useEffect(() => {
    const handleResize = () => {
      if (gridRef.current) {
        gridRef.current.style.height = `${window.innerHeight - 260}px`;
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const inActiveColumns = [
    {
      field: "FLname",
      headerName: "Full Name",
      width: 200,
      renderCell: (params) => {
        return (
          <div
            onClick={() => {
              sessionStorage.setItem(
                "CustomerId_CRMCall",
                params.row.CustomerId
              );
              sessionStorage.setItem(
                "CustomerFLname_CRMCall",
                params.row.FLname
              );
              sessionStorage.setItem(
                "CustomerCode_CRMCall",
                params.row.CustomerCode
              );
              navigate("/CrmDetail");
            }}
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              justifyContent: "center",
            }}
          >
            <p
              style={{
                height: "20px",
                margin: "0px",
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                textDecoration: "underline",
              }}
            >
              {params.row.Firstname} {params.row.Lastname}
            </p>
            <p
              style={{
                height: "20px",
                margin: "0px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {params.row.CustomerCode}
            </p>
          </div>
        );
      },
    },
    { field: "mobileno", headerName: "Mobile No.", width: 150 },
    { field: "email1", headerName: "Email", width: 250 },
  ];

  useEffect(() => {
    setIsLoading(true);
    CommonAPImain("CRM_InActiveCustomerList")
      .then((response) => {
        setIsLoading(false);
        if (response?.Data?.DT) {
          const updatedRows = response.Data.DT.map((item, index) => ({
            id: index + 1,
            ...item,
          }));
          setInActiveRows(updatedRows);
          setInActiveRows((prevRows) => [...updatedRows]);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("API Error:", err);
      });
  }, [activeTabInactive]);

  useEffect(() => {
    if (gridRef.current) {
      gridRef.current.style.height = `${window.innerHeight - 260}px`;
    }
  }, [inActiveRows]);

  const handleSearchInactive = (event) => {
    setInActiveSearchQuery(event.target.value.toLowerCase());
  };

  const inActiveFilteredRows = inActiveRows.filter((row) => {
    const matchesFilters =
      (!CustomerCode ||
        row.CustomerCode.toLowerCase().includes(CustomerCode.toLowerCase())) &&
      (!Email || row.email1.toLowerCase().includes(Email.toLowerCase())) &&
      (!FullName ||
        row.FLname.toLowerCase().includes(FullName.toLowerCase())) &&
      (!MobileNo || row.mobileno.includes(MobileNo));

    const matchesSearchQuery =
      !inActiveSearchQuery ||
      row.CustomerCode.toLowerCase().includes(inActiveSearchQuery) ||
      row.email1.toLowerCase().includes(inActiveSearchQuery) ||
      row.FLname.toLowerCase().includes(inActiveSearchQuery) ||
      row.mobileno.includes(inActiveSearchQuery);
    return matchesFilters && matchesSearchQuery;
  });

  const inActiveClearSearch = () => {
    setInActiveSearchQuery("");
  };

  //active............................
  const [activeRowsData, setActiveRowsData] = useState([]);
  const [activeSearchQuery, setActiveSearchQuery] = useState("");

  useEffect(() => {
    const handleResize = () => {
      if (gridRef.current) {
        gridRef.current.style.height = `${window.innerHeight - 260}px`;
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columnsActiveData = [
    {
      field: "FLname",
      headerName: "Full Name",
      width: 130,
      renderCell: (params) => {
        return (
          <div
            onClick={() => {
              sessionStorage.setItem(
                "CustomerId_CRMCall",
                params.row.CustomerId
              );
              sessionStorage.setItem(
                "CustomerFLname_CRMCall",
                params.row.FLname
              );
              sessionStorage.setItem(
                "CustomerCode_CRMCall",
                params.row.CustomerCode
              );

              navigate("/CrmDetail");
            }}
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              justifyContent: "center",
            }}
          >
            <p
              style={{
                height: "20px",
                margin: "0px",
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                textDecoration: "underline",
              }}
            >
              {params.row.Firstname} {params.row.Lastname}
            </p>
            <p
              style={{
                height: "20px",
                margin: "0px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {params.row.CustomerCode}
            </p>
          </div>
        );
      },
    },
    {
      field: "OrderCnt",
      headerName: "Order Count",
      width: 120,
      renderCell: (params) => {
        return (
          <div>
            <p style={{ margin: "0px", textAlign: "center" }}>
              {params.row.OrderCnt}
            </p>
          </div>
        );
      },
    },
    { field: "mobileno", headerName: "Mobile No.", width: 120 },
    { field: "email1", headerName: "Email", width: 200 },
  ];

  useEffect(() => {
    setIsLoading(true);
    CommonAPImain("CRM_ActiveCustomerList")
      .then((response) => {
        setIsLoading(false);
        if (response?.Data?.DT) {
          const newRows = response.Data.DT.map((item, index) => ({
            id: index + 1,
            ...item,
          }));
          setActiveRowsData(newRows);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("API Error:", err);
      });
  }, [activeTab]);

  const activeTabHandleSearch = (event) => {
    setActiveSearchQuery(event.target.value.toLowerCase());
  };

  const activeDatafilteredRows = activeRowsData.filter((row) => {
    const matchesFilters =
      (!CustomerCode ||
        row.CustomerCode.toLowerCase().includes(CustomerCode.toLowerCase())) &&
      (!Email || row.email1.toLowerCase().includes(Email.toLowerCase())) &&
      (!FullName ||
        row.FLname.toLowerCase().includes(FullName.toLowerCase())) &&
      (!MobileNo || row.mobileno.includes(MobileNo));

    const matchesSearchQuery =
      !activeSearchQuery ||
      row.CustomerCode.toLowerCase().includes(activeSearchQuery) ||
      row.email1.toLowerCase().includes(activeSearchQuery) ||
      row.FLname.toLowerCase().includes(activeSearchQuery) ||
      row.mobileno.includes(activeSearchQuery);

    return matchesFilters && matchesSearchQuery;
  });

  const activeTabClearSearch = () => {
    setActiveSearchQuery("");
  };

  return (
    <div className={`crm-container ${showSearchBar ? "search-active" : ""}`}>
      <div className="tabs">
        <button
          className={`tab-button ${activeTab === "new" ? "active" : ""}`}
          onClick={() => handleTabChange("new")}
        >
          New
        </button>
        <button
          className={`tab-button ${activeTab === "active" ? "active" : ""}`}
          onClick={() => handleTabChange("active")}
        >
          Active
        </button>
        <button
          className={`tab-button ${activeTab === "inactive" ? "active" : ""}`}
          onClick={() => handleTabChange("inactive")}
        >
          Inactive
        </button>
        <button
          className={`tab-button ${activeTab === "search" ? "active" : ""}`}
          onClick={() => handleTabChange("search")}
        >
          Filter
        </button>
      </div>
      <div className="tab-content">
        {activeTab === "new" && (
          <div style={{ height: "100vh - 500px" }}>
            <div className="srm_top_common_div">
              <CustomTextField
                value={searchQuery}
                onChange={handleSearch}
                placeholder="Search .."
                InputProps={{
                  endAdornment: searchQuery && (
                    <IconButton onClick={clearSearch}>
                      <IoMdClose className="catelog_searchClose_icone" />
                    </IconButton>
                  ),
                }}
                className="searchBox_input"
              />
            </div>
            <div
              ref={gridRef}
              style={{
                width: "100%",
                backgroundColor: "white",
              }}
            >
              <DataGrid
                rows={filteredRows}
                columns={columns}
                loading={isLoading}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5, 10, 20]}
                disableRowSelectionOnClick
                className="newGrid_main"
                localeText={{ noRowsLabel: "No Data" }}
              />
            </div>
          </div>
        )}

        {activeTab === "active" && (
          <div style={{ height: "100vh - 500px" }}>
            <div className="srm_top_common_div">
              <CustomTextField
                value={activeSearchQuery}
                onChange={activeTabHandleSearch}
                placeholder="Search .."
                InputProps={{
                  endAdornment: activeSearchQuery && (
                    <IconButton onClick={activeTabClearSearch}>
                      <IoMdClose className="catelog_searchClose_icone" />
                    </IconButton>
                  ),
                }}
                className="searchBox_input"
              />
            </div>
            <div
              ref={gridRef}
              style={{
                width: "100%",
                backgroundColor: "white",
              }}
            >
              <DataGrid
                rows={activeDatafilteredRows}
                columns={columnsActiveData}
                loading={isLoading}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5, 10, 20]}
                disableRowSelectionOnClick
                className="newGrid_main"
                localeText={{ noRowsLabel: "No Data" }}

              />
            </div>
          </div>
        )}

        {activeTab === "inactive" && (
          <div style={{ height: "100vh - 500px" }}>
            <div className="srm_top_common_div">
              <CustomTextField
                value={inActiveSearchQuery}
                onChange={handleSearchInactive}
                placeholder="Search .."
                InputProps={{
                  endAdornment: inActiveSearchQuery && (
                    <IconButton onClick={inActiveClearSearch}>
                      <IoMdClose className="catelog_searchClose_icone" />
                    </IconButton>
                  ),
                }}
                className="searchBox_input"
              />
            </div>
            <div
              ref={gridRef}
              style={{
                width: "100%",
                backgroundColor: "white",
              }}
            >
              <DataGrid
                rows={inActiveFilteredRows}
                columns={inActiveColumns}
                loading={isLoading}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5, 10, 20]}
                disableRowSelectionOnClick
                className="newGrid_main"
                localeText={{ noRowsLabel: "No Data" }}
              />
            </div>
          </div>
        )}

        {activeTab === "search" && <div>Search Content</div>}
      </div>

      <div
        ref={searchBarRef}
        className={`search_bar_crm ${showSearchBar ? "open" : ""}`}
      >
        <div className="search_box_container_top_div">
          {isAnyFilterEntered ? (
            <p className="filter_text_clear" onClick={handleClearFilters}>
              Clear Filter
            </p>
          ) : (
            <p className="filter_text">Filter Data</p>
          )}
          <p
            className="filter_close_text"
            onClick={() => setShowSearchBar(false)}
          >
            Close
          </p>
        </div>
        <div className="search_box_container_div">
          <CustomTextField
            placeholder="CustomerCode"
            value={filters.CustomerCode}
            onChange={(e) => handleFilterChange("CustomerCode", e.target.value)}
          />
          <CustomTextField
            placeholder="Email"
            value={filters.Email}
            onChange={(e) => handleFilterChange("Email", e.target.value)}
          />
        </div>

        <div className="search_box_container_div">
          <CustomTextField
            placeholder="Full Name"
            value={filters.FullName}
            onChange={(e) => handleFilterChange("FullName", e.target.value)}
          />
          <CustomTextField
            placeholder="MobileNo."
            value={filters.MobileNo}
            onChange={(e) => handleFilterChange("MobileNo", e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default Crm;
